import type { RecentOrderResponseOrdersItem } from './recentOrderResponseOrdersItem';

export interface RecentOrderResponse {
  message?: string;
  orders?: RecentOrderResponseOrdersItem[];
  success: boolean;
}
